/**
 * Product Card — Swatches + Size selector (mobile toggle)
 */

(function () {
  function init() {
    // ── Color swatches ──
    document.querySelectorAll('.product-card__swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        var card = this.closest('[data-product-card]');
        card.querySelectorAll('.product-card__swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        this.classList.add('active');
      });
    });

    // ── Mobile: botón + abre tallas ──
    document.querySelectorAll('.product-card__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var card = this.closest('[data-product-card]');
        var li = card.closest('.grid__item');
        var isActive = (li && li.classList.contains('active')) || card.classList.contains('active');

        // Cerrar todos
        document.querySelectorAll('.grid__item.active').forEach(function (el) { el.classList.remove('active'); });
        document.querySelectorAll('.product-card.active').forEach(function (el) { el.classList.remove('active'); });

        if (!isActive) {
          if (li) li.classList.add('active');
          card.classList.add('active');
        }
      });
    });

    // ── Cerrar tallas ──
    document.querySelectorAll('.product-card__sizes-close').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('.grid__item.active').forEach(function (el) { el.classList.remove('active'); });
        document.querySelectorAll('.product-card.active').forEach(function (el) { el.classList.remove('active'); });
      });
    });

    document.querySelectorAll('.product-card__sizes-backdrop').forEach(function (bd) {
      bd.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('.grid__item.active').forEach(function (el) { el.classList.remove('active'); });
        document.querySelectorAll('.product-card.active').forEach(function (el) { el.classList.remove('active'); });
      });
    });
  }

  // Init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinit in theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

  // Reinit after infinite scroll
  window.addEventListener('product-cards:reinit', init);
})();
